import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useSelector } from '../../store/utils';

import { ButtonBox } from '../../molecules/button-box';
import { BoilerTestWizard } from './boiler-test-wizard';

type Props = {
  variant?: 'fullscreen' | 'dialog';
};

export const BoilerTestTrigger = ({ variant }: Props) => {
  const [open, setOpen] = useState(false);

  const inProgress = useSelector((s) => s.variables.HW_SSR_TEST_IN_PROGRESS);

  return (
    <>
      <ButtonBox
        title={
          <FormattedMessage
            id="boiler_test_trigger.title"
            defaultMessage="Test bojleru"
          />
        }
        subtitle={
          <FormattedMessage
            id="boiler_test_trigger.subtitle"
            defaultMessage="Ověří správné zapojení a zadaný výkon patrony bojleru."
          />
        }
        buttonLabel={
          inProgress ? (
            <FormattedMessage
              id="boiler_test_trigger.button.running"
              defaultMessage="Test probíhá"
            />
          ) : (
            <FormattedMessage
              id="boiler_test_trigger.button"
              defaultMessage="Otestovat bojler"
            />
          )
        }
        visibility={{ variableId: 'HW_INSTALL' }}
        onClick={() => setOpen(true)}
        fullWidth
      />
      <BoilerTestWizard
        open={open}
        onClose={() => setOpen(false)}
        variant={variant}
      />
    </>
  );
};
